import { useCallback } from 'react';

import {
  SubscriptionEvent,
  useSettingsStream,
} from '@/hooks/query-hooks/streams/gaia-api/use-settings-stream';
import { Setting, settingsStreamQuery } from '@/queries/gaia-api/settings-stream-query';
import { GaiaQueryWithAgentId } from '@/queries/types';

import { SubscriptionIdentifier, useSubscriptionBase } from './use-subscription-base';

interface UseSettingsProps extends GaiaQueryWithAgentId {
  settingIds?: SubscriptionIdentifier[];
}

/**
 * Subscribe to settings stream with given settingIds and get back mapped results
 *
 * @param agentId The agent ID
 * @param settingIds The list of setting IDs to subscribe to
 */
export const useSettingsSubscription = ({ agentId, settingIds }: UseSettingsProps) => {
  const { enabled, queryKey } = settingsStreamQuery({ agentId });
  const { sendContent, isConnected } = useSettingsStream();
  const handleSendContent = useCallback(
    (subscriptionIds: string[]) => {
      sendContent({
        setting_ids: subscriptionIds,
      } as SubscriptionEvent);
    },
    [sendContent]
  );

  return useSubscriptionBase<Setting>({
    enabled: !!enabled,
    queryKey: queryKey as string[],
    isConnected,
    handleSendContent,
    subscriptionIds: settingIds,
  });
};
